import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './index.css';

createRoot(document.getElementById('root')).render(<App />);

// Single SW: sw-offline.js (merged CRA-style behavior)
const isLocalhost = Boolean(
	window.location.hostname === 'localhost' ||
	window.location.hostname === '[::1]' ||
	/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/.test(window.location.hostname)
);

function registerValidSW(swUrl) {
	return navigator.serviceWorker
		.register(swUrl)
		.then((registration) => {
			registration.onupdatefound = () => {
				const installingWorker = registration.installing;
				if (installingWorker == null) return;
				installingWorker.onstatechange = () => {
					if (installingWorker.state === 'installed') {
						if (navigator.serviceWorker.controller) {
							console.log('New version found. Will activate on next reload.');
						} else {
							console.log('Stored in cache for offline use');
						}
					}
				};
			};

			// Clean up any previous SWs not using sw-offline.js
			navigator.serviceWorker.getRegistrations().then((regs) => {
				for (const reg of regs) {
					const url = reg.active?.scriptURL || reg.installing?.scriptURL || reg.waiting?.scriptURL;
					if (url && !url.endsWith('/sw-offline.js')) reg.unregister();
				}
			});

			return registration;
		});
}

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
	const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
	if (publicUrl.origin === window.location.origin) {
		window.addEventListener('load', () => {
			const swUrl = '/sw-offline.js';
			registerValidSW(swUrl).catch((err) => {
				console.error('Service Worker registration failed:', err);
			});
		});
	}
}